const ICON_PROPS = {
  viewBox: "0 0 24 24",
  width: 20,
  height: 20,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export function IconBarcode() {
  return (
    <svg {...ICON_PROPS} aria-hidden="true">
      <path d="M4 7v10" />
      <path d="M7 7v10" />
      <path d="M9 7v10" />
      <path d="M12 7v10" />
      <path d="M14 7v10" />
      <path d="M17 7v10" />
      <path d="M20 7v10" />
    </svg>
  );
}
